export default "__VITE_ASSET__8eb8924b__"